import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

export const StyledContainer = styled.div`
  display: flex;

  width: 100%;
  align-items: flex-start;
  justify-content: center;
  margin-top: 8px;

  background-color: ${theme.colors.white};
  ${MediaQueries.mbDown} {
    flex-direction: column;
  }
`

export const StyledLeftContainer = styled.div`
  width: 60%;
  padding-right: 50px;
  ${MediaQueries.mbDown} {
    width: 100%;
    padding: 0;
  }
`

export const StyledBorderContainer = styled.div`
  position: relative;
  display: flex;
  overflow: visible;
  width: 40%;
  flex: 1;
  align-items: flex-start;
  align-self: stretch;

  justify-content: flex-start;

  &[data-border='true'] {
    border-left: 1px solid ${theme.colors.neutral100};
  }
  ${MediaQueries.mbDown} {
    width: 100%;
  }
`

export const StyledOneColumnContainer = styled.div`
  position: relative;
  overflow: visible;
`
